/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_None_SelectedInputs */

const en_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No preset selected`)
};

const fr_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun prereglage selectionne`)
};

const de_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellung ausgewählt`)
};

const it_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset selezionato`)
};

const ru_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно заданные параметры не выбраны`)
};

const es_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha seleccionado ningún ajuste preestablecido`)
};

const zh_cn2_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择预设值`)
};

const ja_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが選択されていません`)
};

const hi_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई पूर्व निर्धारित सेटिंग चयनित नहीं है`)
};

const pt_pt2_video_export_preset_none_selected = /** @type {(inputs: Video_Export_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição selecionada`)
};

/**
* | output |
* | --- |
* | "No preset selected" |
*
* @param {Video_Export_Preset_None_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_none_selected = /** @type {((inputs?: Video_Export_Preset_None_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_None_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preset_none_selected(inputs)
	if (locale === "de") return de_video_export_preset_none_selected(inputs)
	if (locale === "it") return it_video_export_preset_none_selected(inputs)
	if (locale === "ru") return ru_video_export_preset_none_selected(inputs)
	if (locale === "es") return es_video_export_preset_none_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preset_none_selected(inputs)
	if (locale === "ja") return ja_video_export_preset_none_selected(inputs)
	if (locale === "hi") return hi_video_export_preset_none_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preset_none_selected(inputs)
	return en_video_export_preset_none_selected(inputs)
});